// src/components/common/Logo.tsx
import React from 'react';
import { Box, BoxProps } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import logoLightUrl from '../../assets/laiatools-logo-long.svg';
import logoDarkUrl from '../../assets/laiatools-logo-long-white.svg'; // Assuming you have a white version

interface LogoProps extends BoxProps {
    height?: number;
    isLink?: boolean;
}

const Logo: React.FC<LogoProps> = ({ height = 32, isLink = true, ...props }) => {
    const { themeMode } = useAppSelector((state) => state.ui);

    const logoImage = (
        <Box
            component="img"
            src={themeMode === 'dark' ? logoDarkUrl : logoLightUrl}
            alt="LaiaTools Logo"
            sx={{
                height: height,
                display: 'block',
                verticalAlign: 'middle',
            }}
            {...props}
        />
    );

    if (isLink) {
        return (
            <RouterLink to="/">
                {logoImage}
            </RouterLink>
        );
    }

    return logoImage;
};

export default Logo;